import * as React from "react";

function SvgMoveToImager(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 30 20" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.933 11.25h.317v8.25H.75v-8.25h.316H0v-1.5h1.475c.056-.168.115-.335.177-.5C3.677 3.846 8.889 0 15 0c6.11 0 11.323 3.846 13.348 9.25.062.165.12.332.177.5H30v1.5h-1.067zM15 2c4.983 0 9.274 2.977 11.187 7.25h-4.776A.996.996 0 0020.75 9h-.137A6.744 6.744 0 0015 6a6.743 6.743 0 00-5.613 3H9.25a.996.996 0 00-.662.25H3.813a12.292 12.292 0 013.684-4.684c-.788.681-1.163 1.506-.847 1.953.36.507 1.472.336 2.487-.382 1.014-.719 1.545-1.712 1.186-2.219-.33-.464-1.29-.36-2.228.212A12.196 12.196 0 0115 2z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgMoveToImager;
